import { ArrowRight, CheckCircle2 } from "lucide-react";

const CTABanner = ({ onTryDemo, onStartTrial }) => {
  return (
    <section className="py-20 sm:py-24 bg-white" data-testid="cta-banner-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div
          className="relative rounded-3xl overflow-hidden"
          style={{
            background:
              "linear-gradient(135deg, #122118 0%, #0A2914 60%, #0E3320 100%)",
          }}
        >
          {/* decorative blobs */}
          <div
            aria-hidden
            className="absolute -top-24 -right-24 w-80 h-80 rounded-full blur-3xl opacity-30"
            style={{ background: "#25D366" }}
          />
          <div
            aria-hidden
            className="absolute -bottom-32 -left-24 w-96 h-96 rounded-full blur-3xl opacity-20"
            style={{ background: "#A7F3D0" }}
          />

          <div className="relative grid md:grid-cols-2 gap-10 p-10 sm:p-14 items-center">
            <div>
              <div className="text-xs uppercase font-bold tracking-[0.2em] text-[#25D366]">
                Prêt à commencer ?
              </div>
              <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-[1.1]">
                Donnez une vraie structure aux études à la maison.
              </h2>
              <p className="mt-5 text-lg text-white/75 leading-relaxed max-w-md">
                Essayez gratuitement pendant 30 jours. Voyez la différence — moins
                de chicane, plus de routine.
              </p>

              <div className="mt-8 flex flex-col sm:flex-row gap-3">
                <button
                  type="button"
                  onClick={onStartTrial}
                  data-testid="cta-banner-subscribe-button"
                  className="inline-flex items-center justify-center gap-2 rounded-full px-7 py-4 text-base font-semibold transition-all"
                  style={{
                    background: "var(--sp-primary)",
                    color: "var(--sp-text-on-primary)",
                  }}
                >
                  Commencer gratuitement maintenant
                  <ArrowRight className="w-4 h-4" />
                </button>
                <button
                  onClick={onTryDemo}
                  data-testid="cta-banner-demo-button"
                  className="inline-flex items-center justify-center gap-2 rounded-full px-7 py-4 text-base font-semibold text-white border border-white/20 hover:bg-white/10 transition-all"
                >
                  Voir la démo
                </button>
              </div>

              <div className="mt-5 flex flex-wrap gap-x-6 gap-y-2 text-sm text-white/70">
                <span className="inline-flex items-center gap-2">
                  <CheckCircle2 className="w-4 h-4 text-[#25D366]" />
                  Essai gratuit 30 jours
                </span>
                <span className="inline-flex items-center gap-2">
                  <CheckCircle2 className="w-4 h-4 text-[#25D366]" />
                  Annulation en 1 clic
                </span>
              </div>
            </div>

            <div className="relative hidden md:block">
              <img
                alt="Parent et enfant qui étudient ensemble"
                src="https://images.pexels.com/photos/8055144/pexels-photo-8055144.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                className="w-full h-72 object-cover rounded-2xl shadow-2xl"
                loading="lazy"
              />
              <div
                className="absolute -bottom-4 -left-4 rounded-2xl p-4 bg-white shadow-xl flex items-center gap-3 border border-gray-100"
              >
                <span
                  className="w-10 h-10 rounded-xl flex items-center justify-center"
                  style={{ background: "#E9FBF0" }}
                >
                  <CheckCircle2 className="w-5 h-5 text-[#189346]" />
                </span>
                <div>
                  <div className="text-xs text-gray-500">Cette semaine</div>
                  <div className="text-sm font-semibold text-[#122118]">
                    4/4 séances complétées 🎉
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
